import Button from '@mui/material/Button';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { getMetaData } from '../../../tool';
import AnswerView from './answer';
import { Comment } from '../../../types';
import useAnswerPageStyles from './useAnswerPageStyles';
import useAnswerPage from '../../../hooks/useAnswerPage';
import useGlobalStyles from '../../useGlobalStyles';
import useLayoutStyles from '../../layout/useLayoutStyles';
import AnswerHeader from './answerHeader';
import GameParrot from '../gameParrot';
import LoadingScreen from '../../loadingScreen';

/**
 * AnswerPage component that displays the full content of a question along with its answers.
 * It also includes the functionality to vote, ask a new question, and post a new answer.
 */
const AnswerPage = () => {
  const { classes } = useAnswerPageStyles();
  const { classes: layoutClasses } = useLayoutStyles();
  const { classes: globalClasses } = useGlobalStyles();

  const {
    question,
    questionID,
    answers,
    orderBy,
    orderByTypes,
    handleNewComment,
    handleNewAnswer,
    handleOrderChange,
  } = useAnswerPage();

  if (!question || question?._id !== questionID) {
    return <LoadingScreen />;
  }

  return (
    <>
      <AnswerHeader />
      <div className={layoutClasses.container}>
        <div className={`${layoutClasses.spaceBetween} ${classes.ansAddHeader}`}>
          <div
            className={`${layoutClasses.boldTitle}`}>{`Answers (${question.answers.length})`}</div>
          <ToggleButtonGroup
            value={orderBy}
            exclusive
            aria-label='notification type'
            onChange={handleOrderChange}>
            {orderByTypes.map(order => (
              <ToggleButton
                className={classes.btn}
                key={order}
                value={order}
                selected={orderBy === order}
                aria-label={order}>
                {order}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          <Button
            className={`${globalClasses.button} ${classes.ansButton}`}
            onClick={() => {
              setTimeout(() => {
                handleNewAnswer();
              }, 200);
            }}>
            Answer Question
          </Button>
        </div>
        {answers.length > 0 ? (
          answers.map((a, idx) => (
            <AnswerView
              key={idx}
              text={a.text}
              ansByUser={a.ansByUser}
              meta={getMetaData(new Date(a.ansDateTime))}
              comments={a.comments}
              handleAddComment={(comment: Comment) => handleNewComment(comment, 'answer', a._id)}
            />
          ))
        ) : (
          <div className={`${globalClasses.notExist} ${classes.noAnswers}`}>No answers yet.</div>
        )}
      </div>
      <GameParrot />
    </>
  );
};

export default AnswerPage;
